import { render, staticRenderFns } from "./ColumnNumberEditor.vue?vue&type=template&id=89a13ef4"
import script from "./ColumnNumberEditor.vue?vue&type=script&lang=js"
export * from "./ColumnNumberEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports